import { render, staticRenderFns } from "./HitWordManageTab.vue?vue&type=template&id=5f328df4&scoped=true"
import script from "./HitWordManageTab.vue?vue&type=script&lang=js"
export * from "./HitWordManageTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f328df4",
  null
  
)

export default component.exports